































import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import store from '@/store'
import ClientDetail, { Client } from '@/components/client-work-detail.vue'
// const clients: Clients = require('@/assets/clients.json')

interface ExtendsClinet extends Client {
  delay: number
  isSelected: boolean
}
interface Clients {
  items: ExtendsClinet[]
}

export default Vue.extend({
  components: {
    ClientDetail
  },

  data() {
    return {
      clients: [] as ExtendsClinet[],
      client: {} as ExtendsClinet
    }
  },

  created() {
    this.fetch(process.env)
  },

  methods: {
    async fetch(env) {
      const wpSiteUrl = env.NODE_ENV === 'development' ? env.VUE_APP_DEV_WP_SITE_URL : env.VUE_APP_PRO_WP_SITE_URL
      const response = await fetch(`${wpSiteUrl}/wp-json/wp/v2/posts?per_page=50&acf_format=standard`)
      let posts = await response.json()

      posts = posts.map((post, index) => {
        const gallery = post.acf.gallery.map(item => ({ src: item.sizes.large, caption: item.caption }))
        const projects = post.acf.project.map(item => ({ name: item.project_name, url: item.url }))
        const data: ExtendsClinet = {
          oneLetter: post.acf.one_letter,
          clientName: post.title.rendered,
          clientDescription: post.acf.client_description,
          clientSite: post.acf.client_site,
          gallery,
          projects,
          designSelectionAward: post.acf.design_selection_award,
          delay: index * 100,
          isSelected: false
        }
        return data
      })
      posts = this.shuffle(posts)

      this.clients.push(...posts)
    },
    open(client: ExtendsClinet) {
      if (this.client) {
        if (!this.client.isSelected) {
          this.client = client
          document.body.style.height = '100vh'
          document.body.style.overflow = 'hidden'
        }
      }
    },
    close() {
      this.client = {} as ExtendsClinet
      document.body.style.height = ''
      document.body.style.overflow = ''
    },
    shuffle(array: any[]) {
      for (let i = array.length - 1; i >= 0; i--) {
        const rand = Math.floor(Math.random() * (i + 1)) as number
        [array[i], array[rand]] = [array[rand], array[i]]
      }
      return array
    },
    removeTransitonDelay(el: HTMLElement) {
      el.style.transitionDelay = ''
    }
  }
})
